import store from '@/store'
import { v2Host } from '@/config/host'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import { getApiPath } from '@/common/api-proxy.js'
import { computed, watch, nextTick, ref } from 'vue'
import type {
  IFileUploadConfig,
  TableColumnType,
  FileUploadModelType,
  OptionItemType,
} from './type'
import type { fileMetaType } from '@/api/public_resource/type'
import { getFileUploadConfig } from './dialog'
import FileUploader from '@/components/FileUploader/index.vue'
import type {
  GetAssetListParams,
  FromModelType,
  GetLabelAllParams,
} from '@/api/public_resource/type'
import type { FileData, FileType } from '@/api/material_label/type'
import LanguageSelector from '@/components/LanguageSelector/index.vue'
import tagTascader from '@/views/repository/labels/components/tag-cascader.vue'
import { ApplicableResourcesType, TabsType, Operation } from './enums'
import { SkeletonType } from '@com/enums/model'
import _ from 'lodash'
import { getFileExtension } from '@com/utils/file'
import {
  validate3DModel,
  validateActionModel,
} from '@com/utils/model-file-meta'

import {
  resourcesList,
  tabMapOptions,
  statusOptions,
  copyrightOptions,
  sourceOptions,
  publicOptions,
  applicableOptions,
  skeletonOptions,
  realizeOptions,
  auditStatusOption,
  videoApplicableOptions,
  flowerWordOptions,
  applicableResourcesOptions,
  animationOptions,
  animationTypesOption,
  accessAllowOptions,
} from './option'

export const loading = ref<boolean>(false)

const resource = computed(() => store.state.resource)

const newTabMapOptions = tabMapOptions.slice(1)

// 预设库、片段库不支持新增资源
const typeTabMapOptions = newTabMapOptions.map((obj) => ({ ...obj }))
typeTabMapOptions.map((t) => {
  if (t.value === TabsType.PRESETS || t.value === TabsType.FRAGMENT) {
    t.disabled = true
  }
  return t
})

// 应用范围
const getApplicableOptions = (val: TabsType) => {
  // 花字、转场、滤镜、动画
  if (
    val === TabsType.FLOWERWORD ||
    val === TabsType.TRANSITION ||
    val === TabsType.FILTER ||
    val === TabsType.ANIMATION
  ) {
    return videoApplicableOptions
    // 预设
  } else if (
    val === TabsType.PRESETS ||
    val === TabsType.MODEL ||
    val === TabsType.ACTION
  ) {
    return applicableOptions.filter((t) => t.value === 1)
  }
  return applicableOptions
}

export const formItemQuery: GetAssetListParams = {
  searchName: 'name',
  keyWords: '',
  types: '',
  show_statuses: [],
  tag_id: '',
  group_id: '',
  copyrights: '',
  sources: '',
  public: '',
  applicable_tools: '',
  description: '',
  audit_status: '',
  id: '',
  name: '',
  order: '-updated_time',
  realize_methods: '',
  language: '',
  adapter_resource: '',
  cartoon_type: '',
  flower_word_type: '',
  no_tag: false,
  page: 1,
  page_size: 15,
  tag_ids: '',
  ai_tag_ids: '',
  only_inner: '',
}

export const formItemSearch = [
  {
    prop: 'searchName',
    type: 'select',
    class: 'offer-selector',
    params: {
      options: resourcesList,
    },
  },

  {
    prop: 'keyWords',
    type: 'input',
    class: 'offer-input',
    subtype: '',
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    params: ({ formItem, formValue }: { formItem: any; formValue: any }) => {
      nextTick(() => {
        formItem.subtype = formValue.searchName === 'id' ? 'number' : ''
        // formValue.keyWords = ''
      })
      return {
        placeholder: '请输入关键词',
        clearable: true,
      }
    },
  },

  {
    label: '资源类型:',
    type: 'select',
    prop: 'types',
    visible: false,
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: newTabMapOptions,
    },
  },
  {
    label: '上架状态:',
    type: 'select',
    prop: 'show_statuses',
    visible: true,
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: statusOptions,
    },
  },
  {
    label: '版权状态:',
    type: 'select',
    prop: 'copyrights',
    visible: true,
    params: {
      clearable: true,
      options: copyrightOptions,
    },
  },
  {
    label: '资源来源:',
    type: 'select',
    prop: 'sources',
    visible: true,
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: sourceOptions,
    },
  },
  {
    label: '是否公开:',
    type: 'select',
    prop: 'public',
    visible: true,
    params: {
      clearable: true,
      options: publicOptions,
    },
  },
  {
    label: '应用范围:',
    type: 'select',
    prop: 'applicable_tools',
    visible: true,
    params: {
      multiple: true,
      clearable: true,
      'collapse-tags': true,
      options: applicableOptions,
    },
  },
  {
    component: LanguageSelector,
    label: '语种:',
    prop: 'language',
    visible: false,
    type: 'component',
  },
  {
    label: '实现方式:',
    type: 'select',
    prop: 'realize_methods',
    visible: false,
    params: {
      clearable: true,
      options: realizeOptions,
    },
  },
  {
    label: '花字类型:',
    type: 'select',
    prop: 'flower_word_type',
    visible: false,
    params: {
      clearable: true,
      options: flowerWordOptions,
    },
  },
  {
    label: '适用资源:',
    type: 'select',
    prop: 'adapter_resource',
    visible: false,
    params: {
      clearable: true,
      options: applicableResourcesOptions,
    },
  },
  {
    label: '动画类型:',
    type: 'select',
    prop: 'cartoon_type',
    visible: false,
    params: {
      clearable: true,
      options: animationOptions,
    },
  },
  {
    label: '骨骼类型:',
    type: 'select',
    prop: 'skeleton_type',
    visible: false,
    params: {
      clearable: true,
      options: skeletonOptions,
    },
  },
  {
    label: '审核状态:',
    type: 'select',
    prop: 'audit_status',
    visible: false,
    params: {
      multiple: true,
      clearable: true,
      'collapse-tags': true,
      options: auditStatusOption,
    },
  },
  {
    label: '是否公开:',
    type: 'select',
    prop: 'only_inner',
    visible: false,
    params: {
      clearable: true,
      options: [
        {
          label: '是，外部可用',
          value: 2,
        },
        {
          label: '否，仅内部使用',
          value: 1,
        },
      ],
    },
  },
]

watch(
  () => resource.value.activeTab,
  (val) => {
    formItemSearch[2]!.visible = val === TabsType.ALL
    formItemSearch[8]!.visible = val === TabsType.FONT
    formItemSearch[9]!.visible = val === TabsType.PARTICLE
    formItemSearch[10]!.visible = val === TabsType.FLOWERWORD
    formItemSearch[11]!.visible = val === TabsType.ANIMATION
    formItemSearch[12]!.visible = val === TabsType.ANIMATION
    // @ts-ignore
    formItemSearch[7]!.params!.options = getApplicableOptions(val)

    formItemSearch[13]!.visible =
      val === TabsType.MODEL || val === TabsType.ACTION
  },
  { immediate: true, deep: true },
)

export const fromModel: FromModelType = {
  name: '',
  name_en: '',
  type: '',
  public: 2,
  tag_ids: '',
  show_status: 1,
  copyright: 0,
  languages: [],
  skeleton_type: 8,
  realize_method: 0,
  applicable_tools: [],
  thumb_url: '',
  thumbList: [],
  fileList: [],
  file_url: '',
  origin_name: '',
  description: '',
  flower_word_type: 0,
  adapter_resources: [],
  cartoon_type: 0,
  // thumb_url_sticker: '',
  // thumbStickerList: [],
  thumb_url_text: '',
  thumbTextList: [],
  file_meta: {
    skeleton_count: 0,
    mesh_count: 0,
    material_count: 0,
    skin_count: 0,
    skeleton_names: [],
    face_count: 0,
    vertex_count: 0,
    has_vertices: false,
    has_normals: false,
    has_UVs: false,
    fps: 0,
    frames: 0,
  },
}

const uploadConfig = {
  action: `${v2Host}${getApiPath('/upload/file')}`,
  headers: {
    'Auth-Token': getToken(),
  },
  drag: true,
}

export const treeParams: GetLabelAllParams = {
  group_type: 4,
  asset_type: 0,
}

let fileUploadConfig: IFileUploadConfig = {
  acceptType: [],
  tip: '',
}

const fileUploadFileList: { name: string; url: string }[] = []

function getApplicableToolsOptions(
  activeTab: number,
  model: Record<string, any>,
) {
  if (
    activeTab === TabsType.FLOWERWORD ||
    activeTab === TabsType.TRANSITION ||
    activeTab === TabsType.FILTER ||
    activeTab === TabsType.ANIMATION
  ) {
    return videoApplicableOptions
  } else if (
    activeTab === TabsType.PRESETS ||
    activeTab === TabsType.MODEL ||
    activeTab === TabsType.ACTION
  ) {
    return applicableOptions.filter((item) => item.value === 1)
  } else if (model && model.file_url && model.file_url.indexOf('gif') > -1) {
    return applicableOptions.filter((item) => item.value !== 1)
  }
  return applicableOptions
}

function getAnimationTypeOptions(
  activeTab: number,
  model: Record<string, any>,
) {
  if (activeTab === TabsType.ANIMATION && model.adapter_resources) {
    return applicableResourcesChange(model.adapter_resources)
  }
  return animationOptions
}

export const validateName = (rule: any, value: string, callback: any) => {
  if (/^\s+$/.test(value)) {
    callback(new Error('不能只存在空格'))
    return
  }
  return callback()
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function fromSchemaFun(
  activeTab: number,
  dialogInfo: Record<string, any>,
  model: Record<string, any>,
) {
  fileUploadConfig = getFileUploadConfig(activeTab)

  // 是否添加粒子模式，添加粒子模式隐藏不需要参数
  const IS_ADD_PARTICLE =
    model &&
    model.type === 5 &&
    dialogInfo &&
    dialogInfo.operation &&
    dialogInfo.operation.indexOf('add') > -1

  // 是否文本预设模式，文本预设模式禁用需要参数
  const IS_FORM_AF =
    // model &&
    // model.type === TabsType.FLOWERWORD &&
    dialogInfo &&
    dialogInfo.operation &&
    dialogInfo.operation === Operation.AF_UPLOAD

  const isAudioAiTag =
    activeTab === TabsType.AUDIO &&
    model.ai_tag_ids &&
    model.ai_tag_ids.length > 0

  console.log(isAudioAiTag, 'isAudioAiTag')

  // 资源标签数据
  let computedCount = 0
  const schema = computed(() => {
    computedCount++
    const fileUrlData = {
      mod: `asset-${activeTab}`,
      bucket: 'mws-files',
    }
    if (activeTab === TabsType.MODEL) {
      // @ts-ignore
      fileUrlData.unzip = 2
    }
    return {
      type: 'object',
      properties: {
        name: {
          component: 'input',
          title: '资源名称：',
          rules: [
            { required: true, message: '资源名称不能为空', trigger: 'blur' },
            {
              validator: validateName,
              trigger: 'blur',
            },
          ],
          field: {
            placeholder: '请输入资源名称',
            style: {
              width: '250px',
            },
          },
        },
        name_en: {
          component: 'input',
          title: '资源英文名：',
          rules: [
            { required: true, message: '资源英文名不能为空', trigger: 'blur' },
            {
              validator: validateName,
              trigger: 'blur',
            },
          ],
          field: {
            placeholder: '请输入资源英文名',
            style: {
              width: '250px',
            },
          },
        },
        type: {
          component: 'select',
          title: '资源类型：',
          visible: resource.value.activeTab === TabsType.ALL,
          rules: [
            { required: true, message: '资源类型不能为空', trigger: 'change' },
          ],
          field: {
            style: {
              width: '250px',
            },
            disabled: IS_ADD_PARTICLE || dialogInfo.id !== 0 || IS_FORM_AF,
            options: typeTabMapOptions,
          },
        },
        languages: {
          component: LanguageSelector,
          title: '语言：',
          visible: activeTab === TabsType.FONT,
          field: {
            style: {
              width: '250px',
            },
            multiple: true,
            'collapse-tags': true,
            clearable: true,
          },
        },
        public: {
          component: 'radio-group',
          title: '是否公开:',
          class: 'radio-selector',
          field: {
            options: publicOptions,
          },
        },
        show_status: {
          component: 'radio-group',
          title: '上架状态:',
          class: 'radio-selector',
          field: {
            options: statusOptions,
            disabled: IS_ADD_PARTICLE,
          },
        },
        copyright: {
          component: 'radio-group',
          title: '版权状态:',
          class: 'radio-selector',
          field: {
            options: copyrightOptions,
          },
        },
        skeleton_type: {
          component: 'radio-group',
          title: '骨骼类型:',
          class: 'radio-selector',
          visible:
            activeTab === TabsType.MODEL || activeTab === TabsType.ACTION,
          field: {
            options: skeletonOptions,
          },
        },
        realize_method: {
          component: 'radio-group',
          title: '实现方式:',
          class: 'radio-selector',
          visible: activeTab === TabsType.PARTICLE,
          field: {
            options: realizeOptions,
            disabled: IS_ADD_PARTICLE,
          },
        },
        applicable_tools: {
          component: 'checkbox-group',
          title: '应用范围:',
          class: 'radio-selector',
          field: {
            options: getApplicableToolsOptions(activeTab, model),
            disabled: IS_ADD_PARTICLE,
          },
        },
        flower_word_type: {
          component: 'radio-group',
          title: '花字类型:',
          rules: [
            { required: true, message: '请选择', trigger: 'change' },
            { validator: typeValidator, trigger: 'change' },
          ],
          class: 'radio-selector',
          visible: activeTab === TabsType.FLOWERWORD,
          field: {
            options: flowerWordOptions,
          },
        },
        adapter_resources: {
          component: 'checkbox-group',
          title: '适用资源:',
          rules: [{ required: true, message: '请选择', trigger: 'change' }],
          class: 'radio-selector',
          visible: activeTab === TabsType.ANIMATION,
          field: {
            options: applicableResourcesOptions,
          },
        },
        cartoon_type: {
          component: 'radio-group',
          title: '动画类型:',
          rules: [
            { required: true, message: '请选择', trigger: 'change' },
            { validator: typeValidator, trigger: 'change' },
          ],
          class: 'radio-selector',
          visible: activeTab === TabsType.ANIMATION,
          field: {
            // options: getAnimationTypeOptions(activeTab, model),
            options: animationOptions,
          },
        },
        tag_ids: {
          title: '资源标签：',
          component: tagTascader,
          isMultiple: true,
          noInitRefresh: computedCount > 1,
          treeParams: {
            ...treeParams,
            asset_type: activeTab,
          },
        },
        ...(isAudioAiTag
          ? {
              ai_tag_ids: {
                title: 'ai 标签：',
                component: tagTascader,
                isMultiple: true,
                noInitRefresh: computedCount > 1,
                treeParams: {
                  ...treeParams,
                  asset_type: activeTab,
                },
              },
            }
          : {}),
        thumb_url: {
          component: FileUploader,
          title: activeTab === TabsType.ANIMATION ? '视频封面图：' : '封面图：',
          visible:
            ([
              TabsType.ALL,
              TabsType.KEEL,
              TabsType.VIDEO,
              TabsType.FONT,
              TabsType.FLOWERWORD,
              TabsType.TRANSITION,
              TabsType.FILTER,
              TabsType.PRESETS,
              TabsType.MODEL,
              TabsType.ACTION,
            ].indexOf(activeTab) !== -1 ||
              (activeTab === TabsType.ANIMATION &&
                model.adapter_resources.indexOf(
                  ApplicableResourcesType.VIDEOPICTURE,
                ) !== -1)) &&
            !IS_ADD_PARTICLE,
          rules:
            activeTab === TabsType.FLOWERWORD ||
            activeTab === TabsType.TRANSITION ||
            activeTab === TabsType.FILTER ||
            activeTab === TabsType.ANIMATION ||
            activeTab === TabsType.MODEL ||
            activeTab === TabsType.ACTION
              ? { required: true, message: '请上传文件', trigger: ['change'] }
              : {},
          field: {
            ...uploadConfig,
            data: {
              mod: `asset-${activeTab}`,
              bucket: 'mws-files',
            },
            accept:
              activeTab === TabsType.PRESETS
                ? '.jpg,.png,.jpeg,.gif'
                : '.jpg,.png,.jpeg,.gif,.svg',
            fileList: model.thumbList,
            tip:
              activeTab === TabsType.PRESETS
                ? '支持JPG、PNG、JPEG、GIF格式,大小不超过2M'
                : '支持JPG、PNG、JPEG、GIF、SVG格式,大小不超过2M',
          },
          handleRemove: (): void => {
            model.thumbList = []
            model.thumb_url = ''
          },
          beforeUpload: beforeUploadThumb,
          handleUploadSuccess: (res: FileData): void => {
            model.thumb_url = res.data.file_path || ''
            model.thumbList = [
              {
                name: res.data.origin_name,
                url: res.data.url,
              },
            ]
          },
        },
        // thumb_url_sticker: {
        //   component: FileUploader,
        //   title: '贴纸封面图：',
        //   visible:
        //     activeTab === TabsType.ANIMATION &&
        //     model.adapter_resources.indexOf(ApplicableResourcesType.TAG) !== -1,
        //   rules: [
        //     {
        //       required: true,
        //       message: '请上传文件',
        //       trigger: ['change'],
        //     },
        //   ],
        //   field: {
        //     ...uploadConfig,
        //     data: {
        //       mod: `asset-${activeTab}`,
        //       bucket: 'mws-files',
        //     },
        //     accept: '.jpg,.png,.jpeg,.gif,.svg',
        //     fileList: model.thumbStickerList,
        //     onChange: onChange,
        //     tip: '支持JPG、PNG、JPEG、GIF、SVG格式,大小不超过2M',
        //   },
        //   handleRemove: (): void => {
        //     model.thumbStickerList = []
        //     model.thumb_url_sticker = ''
        //     // model.prop = 'thumb_url_sticker'
        //     // model.fileList = []
        //   },
        //   beforeUpload: beforeUploadThumb,
        //   handleUploadSuccess: (res: FileData): void => {
        //     model.thumb_url_sticker = res.data.file_path || ''
        //     model.thumbStickerList = [
        //       {
        //         name: res.data.origin_name,
        //         url: res.data.url,
        //       },
        //     ]
        //   },
        // },
        thumb_url_text: {
          component: FileUploader,
          title: '文本封面图：',
          visible:
            activeTab === TabsType.ANIMATION &&
            model.adapter_resources.indexOf(ApplicableResourcesType.TEXT) !==
              -1,
          rules: [
            {
              required: true,
              message: '请上传文件',
              trigger: ['change'],
            },
          ],
          field: {
            ...uploadConfig,
            data: {
              mod: `asset-${activeTab}`,
              bucket: 'mws-files',
            },
            accept: '.jpg,.png,.jpeg,.gif,.svg',
            fileList: model.thumbTextList,
            onChange: onChange,
            tip: '支持JPG、PNG、JPEG、GIF、SVG格式,大小不超过2M',
          },
          handleRemove: (): void => {
            model.thumbTextList = []
            model.thumb_url_text = ''
            // model.prop = 'thumb_url_text'
            // model.fileList = []
          },
          beforeUpload: beforeUploadThumb,
          handleUploadSuccess: (res: FileData): void => {
            model.thumb_url_text = res.data.file_path || ''
            model.thumbTextList = [
              {
                name: res.data.origin_name,
                url: res.data.url,
              },
            ]
          },
        },
        file_url: {
          component: FileUploader,
          title: '上传文件：',
          visible: !(IS_ADD_PARTICLE || dialogInfo.id !== 0),
          rules: [
            {
              required: true,
              message: '请上传文件',
              trigger: ['change'],
            },
          ],
          field: {
            ...uploadConfig,
            data: fileUrlData,
            ...fileUploadConfig,
            fileList: model.fileList,
            onChange: onChange,
            disabled: IS_FORM_AF,
          },
          beforeUpload: (file: FileType) => {
            if (
              [
                TabsType.FLOWERWORD,
                TabsType.FILTER,
                TabsType.ANIMATION,
                TabsType.TRANSITION,
                TabsType.MODEL,
                TabsType.ACTION,
              ].indexOf(activeTab) !== -1
            ) {
              const imgSize = Number(file.size / 1024 / 1024)
              if (imgSize > 5) {
                Message.error('文件大小不能超过5M')
                return false
              }
            }
          },
          handleRemove: (): void => {
            model.fileList = []
            model.file_url = ''
            model.origin_name = ''
          },
          handleUploadSuccess: (res: FileData): void => {
            // gif文件无法应用到可玩工具
            if (
              model.file_url.indexOf('gif') !== -1 &&
              _.isArray(model.applicable_tools)
            ) {
              model.applicable_tools = model.applicable_tools.filter(
                (val) => Number(val) !== 1,
              )
            }
            model.file_url = res.data.file_path || ''
            model.origin_name = res.data.origin_name || ''
            model.fileList = [
              {
                name: res.data.origin_name,
                url: res.data.url,
              },
            ]
            if (activeTab === TabsType.MODEL || activeTab === TabsType.ACTION) {
              model.file_meta = {
                mesh_count: 0,
                material_count: 0,
                skin_count: 0,
                skeleton_count: 0,
                skeleton_names: [],
                face_count: 0,
                vertex_count: 0,
                has_vertices: false,
                has_normals: false,
                has_UVs: false,
                fps: 0,
                frames: 0,
              }
            }
            if (activeTab === TabsType.MODEL) {
              const modelUrl =
                res.data.files.find((url) => {
                  return (
                    getFileExtension(url) === 'glb' ||
                    getFileExtension(url) === 'gltf'
                  )
                }) || ''
              if (modelUrl) {
                loading.value = true
                getModelIfrInfo(modelUrl)
              }
            } else if (activeTab === TabsType.ACTION) {
              // 动作库 上传文件成功后后逻辑处理
              // todo
              const modelUrl = res.data.url

              if (modelUrl) {
                getActionIfrInfo(modelUrl)
                loading.value = true
              }
            }
          },
        },
        description: {
          component: 'input',
          title: '资源描述：',
          prop: 'description',
          field: {
            type: 'textarea',
            placeholder: '请输入内容',
            style: {
              width: '450px',
            },
            maxlength: 30,
            'show-word-limit': true,
          },
        },
      },
    }
  })

  return schema
}

export const fileUploadModel: FileUploadModelType = {
  file_path: [],
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function fromUploadSchemaFun(activeTab: number) {
  return {
    type: 'object',
    properties: {
      file_path: {
        component: FileUploader,
        field: {
          multiple: true,
          ...uploadConfig,
          data: {
            mod: `asset-${activeTab}`,
            bucket: 'mws-files',
          },
          fileList: fileUploadFileList,
          ...getFileUploadConfig(activeTab),
        },
        handleUploadSuccess: (
          res: FileData,
          file: FileType,
          fileList: FileType[],
        ): void => {
          handleUploadSuccess(res, file, fileList, activeTab)
        },
      },
    },
  }
}

export function fromUploadColumnFun(activeTab: number): TableColumnType[] {
  return [
    {
      label: '资源类型',
      prop: 'type',
      align: 'center',
      width: 80,
      show: true,
    },
    {
      prop: 'name',
      slot: 'name',
      show: true,
    },
    {
      prop: 'name_en',
      slot: 'name_en',
      show: true,
    },
    {
      prop: 'thumb_url',
      slot: 'thumb_url',
      show: !(
        activeTab === TabsType.PICTURE ||
        activeTab === TabsType.GRAPH ||
        activeTab === TabsType.AUDIO ||
        activeTab === TabsType.PARTICLE
      ),
    },
    {
      label: 'description',
      slot: 'description',
      show: true,
    },
    {
      label: 'tag_ids',
      slot: 'tag_ids',
      show: true,
    },
    {
      prop: 'realize_method',
      slot: 'realize_method',
      show: activeTab === TabsType.PARTICLE,
    },
    {
      prop: 'applicable_tools',
      slot: 'applicable_tools',
      show: activeTab === TabsType.PARTICLE,
    },
    {
      prop: 'action-cell',
      slot: 'action-cell',
      show: true,
    },
  ]
}

export function batchTagSchemaFun(activeTab: number) {
  return {
    type: 'object',
    properties: {
      tag_ids: {
        component: tagTascader,
        isMultiple: true,
        treeParams: {
          ...treeParams,
          asset_type: activeTab,
        },
      },
      access_allow_pt: {
        component: 'checkbox-group',
        class: 'radio-selector',
        field: {
          options: accessAllowOptions,
        },
      },
    },
  }
}

function onChange(file: FileType, fileList: FileType[]) {
  if (fileList.length > 1) {
    fileList.splice(0, 1)
  }
}

function beforeUploadThumb(file: FileType) {
  // 获取上传文件大小
  const imgSize = Number(file.size / 1024 / 1024)
  if (imgSize > 2) {
    Message.error('文件大小不能超过2M')
    return false
  }
}

function uniqFile(filePath: string) {
  for (const file of fileUploadModel.file_path) {
    if (file.file_url === filePath) {
      return true
    }
  }
  return false
}

// eslint-disable-next-line max-params
function handleUploadSuccess(
  res: FileData,
  file: FileType,
  fileList: FileType[],
  activeTab: number,
): void {
  if (res.code !== 0) {
    Message({
      type: 'error',
      message: res.msg,
    })
  }
  const { origin_name, file_path } = res.data
  if (uniqFile(file_path)) return

  fileUploadModel.file_path.push({
    type: String(
      newTabMapOptions.find((item) => item.value === activeTab)?.label,
    ),
    name: origin_name.replace(/(\.[^.]+)?$/g, ''),
    name_en: origin_name.replace(/(\.[^.]+)?$/g, ''),
    thumb_url: '',
    description: '',
    origin_name: origin_name,
    file_url: file_path,
    realize_method: '',
    tag_ids: [],
    access_allow_pt: false,
  })
}

// 动画库：适用资源不同对应的动画类型
function applicableResourcesChange(val: number[]) {
  let animationTypeList: OptionItemType[] = []
  if (val.length === 0) {
    animationTypeList = animationOptions
  } else if (val.length === 1) {
    animationTypeList = animationTypesOption[val[0]!]!
  } else if (
    val.length > 1 &&
    val.indexOf(ApplicableResourcesType.VIDEOPICTURE) !== -1
  ) {
    animationTypeList = _.intersectionBy(
      animationTypesOption[ApplicableResourcesType.VIDEOPICTURE]!,
      animationTypesOption[ApplicableResourcesType.TEXT]!,
      'value',
    )
  } else {
    animationTypeList = animationTypesOption[ApplicableResourcesType.TEXT]!
  }
  return animationTypeList
}

function typeValidator(rule: any, value: number, callback: any) {
  if (value) {
    callback()
  } else {
    callback(new Error('请选择'))
  }
}

export function getModelIfrInfo(url: string) {
  const ifr = document.getElementById('main_ifr_viewer')
  ifr!.onload = function () {
    console.log('loaded!!!!')
  }
  // @ts-ignore
  ifr!.src = `${targetUrl()}?action=getModelInfo&modelURL=${encodeURIComponent(
    url,
  )}`
}

function getActionIfrInfo(url: string) {
  const ifr = document.getElementById('main_ifr_viewer')
  ifr!.onload = function () {
    console.log('loaded!!!!')
  }
  // @ts-ignore
  ifr!.src = `${targetUrl()}?action=getAnimationInfo&animationURL=${encodeURIComponent(
    url,
  )}`
}

// 3d模型文件检验
export function validateModel(
  skeleton_type: SkeletonType,
  file_meta: fileMetaType,
): string {
  // 顶点、法线、纹理坐标都为true;
  if (!file_meta.has_vertices || !file_meta.has_normals || !file_meta.has_UVs) {
    return '顶点、法线、纹理坐标存在false的情况'
  }
  //  模型网格数量 = 1;
  if (file_meta.mesh_count !== 1) {
    return '模型网格数量不为1'
  }
  //   材质数量=1
  if (file_meta.material_count !== 1) {
    return '材质数量不为1'
  }

  if (
    [
      SkeletonType.SNAKE,
      SkeletonType.SIMPLE,
      SkeletonType.FISH,
      SkeletonType.HUMANOID,
      SkeletonType.REPTILIA,
    ].indexOf(skeleton_type) !== -1
  ) {
    if (file_meta.skin_count !== 1) {
      return '蒙皮数量不为1'
    }
    if (!validate3DModel(skeleton_type, file_meta.skeleton_names)) {
      return '骨骼名称与蓝本不一致'
    }
  } else if ([SkeletonType.BIRD].indexOf(skeleton_type) !== -1) {
    if (file_meta.skin_count !== 1) {
      return '蒙皮数量不为1'
    }
  }
  return ''
}

// 动作文件检验
export function validateAction(
  skeleton_type: SkeletonType,
  file_meta: fileMetaType,
): string {
  // 动作帧率≤30帧
  if (file_meta.fps > 30) {
    return '动作帧率需≤30帧'
  }
  // 网格数 = 0
  if (file_meta.mesh_count) {
    return '网格数不为0'
  }
  // 骨骼名称必须在蓝本骨骼中能找到，否则认为匹配失败
  if (!validateActionModel(skeleton_type, file_meta.skeleton_names)) {
    return '骨骼名称与蓝本骨骼不一致'
  }
  return ''
}

export function targetUrl() {
  return '/common-viewer/gltfViewer/dist/index.html'
}
